import * as PRIVILEGES from 'commons/constants/user_privileges';
import { NAVIGATION } from '../constants/universal_header.js';

const MOD_PAGES = [ NAVIGATION.LEGACY_ANALYTICS, NAVIGATION.CONSOLE, NAVIGATION.USERS, NAVIGATION.SWITCH_SITES ];
const GLOBAL_MOD_PAGES = [ NAVIGATION.SWITCH_SITES ].concat(MOD_PAGES);
const ADMIN_PAGES = [ NAVIGATION.ANALYTICS, NAVIGATION.SWITCH_SITES, NAVIGATION.SITE_SETTINGS ].concat(MOD_PAGES);
const GLOBAL_ADMIN_PAGES = [ NAVIGATION.CLIENTS, NAVIGATION.PORTAL ].concat(ADMIN_PAGES);

export const canView = (page, user) => getAllowedPages(user).includes(page);

function getAllowedPages(user) {
    switch (user.user_privilege) {
        case PRIVILEGES.GLOBAL_ADMINISTRATOR:
            return GLOBAL_ADMIN_PAGES;
        case PRIVILEGES.GLOBAL_MODERATOR:
            return GLOBAL_MOD_PAGES;
        case PRIVILEGES.ADMINISTRATOR:
            return ADMIN_PAGES;
        case PRIVILEGES.MODERATOR:
            return MOD_PAGES;
        default:
            return [];
    }
}
